module.exports = __webpack_public_path__ + "static/media/bkg50n.17d5bf05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg50n.jpg
// module id = 480
// module chunks = 0